import { render, staticRenderFns } from "./ProjectMemberCard.vue?vue&type=template&id=ec59beb6&scoped=true&"
import script from "./ProjectMemberCard.vue?vue&type=script&lang=ts&"
export * from "./ProjectMemberCard.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectMemberCard.vue?vue&type=style&index=0&id=ec59beb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec59beb6",
  null
  
)

export default component.exports